import React from "react";
import { useSelector } from "react-redux";
import AllRoutes from "./routes/Routes";
import TokenRefreshHandler from "./components/TokenRefreshHandler";
import SessionKeeper from "./components/SessionKeeper";
import MogaChatbot from "./components/MogaChatbot";
import { RootState } from "./redux/store";
import "./assets/scss/Default.scss";
import "./assets/scss/Icons.scss";
import "./assets/scss/moga-dropdowns.scss";
import "react-bootstrap-country-select/dist/react-bootstrap-country-select.css";
import "react-datepicker/dist/react-datepicker.css";
import useLanguageChange from "./hooks/useLanguageChange";
import { useBackgroundNotifications } from "./hooks/useBackgroundNotifications";
import { message } from "antd";

message.config({ maxCount: 4, duration: 3.5 });

const App = () => {
  useLanguageChange();
  const user = useSelector((state: RootState) => state.Auth?.user);
  // Initialize background notifications (service worker + push subscriptions)
  useBackgroundNotifications(!!user);

  return (
    <>
      {user && <TokenRefreshHandler />}
      {user && <SessionKeeper />}
      <React.Fragment>
        <AllRoutes />
      </React.Fragment>
      {user && <MogaChatbot />}
    </>
  );
};

export default App;
